// @generated by protobuf-ts 2.8.2 with parameter output_javascript
// @generated from protobuf file "kalos_devices.proto" (syntax proto3)
// tslint:disable
import { DeviceService } from "./kalos_devices";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service DeviceService
 */
export class DeviceServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = DeviceService.typeName;
        this.methods = DeviceService.methods;
        this.options = DeviceService.options;
    }
    /**
     * @generated from protobuf rpc: Create(Device) returns (Device);
     */
    create(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get(Device) returns (Device);
     */
    get(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGet(Device) returns (DeviceList);
     */
    batchGet(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update(Device) returns (Device);
     */
    update(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete(Device) returns (Device);
     */
    delete(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
